import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAngularEvent, IAugmentedJQuery, IQService, IScope, ITimeoutService, IWindowService} from "angular";
import {StateService, TransitionService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {WebModulnavn, WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {RedigerOppgaveDialog} from "../oppgave/modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {Utlogging} from "../../tjenester/Utlogging";
import {Debugger} from "debug";
import {KlientinformasjonFraUserAgent} from "felles/tjenester/KlientinformasjonFraUserAgent";
import {Konfigurasjon, Miljø} from "../../../felles/infrastruktur/Konfigurasjon";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {CdkScrollableSomTjenesteForAjs, Ng2DialogTjenesterForAjs, PresentasjonsmodusTjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {CdkScrollable} from "@angular/cdk/scrolling";

const debug: Debugger = require('debug')('BasisKontroller');
const css = require('./basis.scss');

export class BasisKontroller {

    static regNavn = "BasisKontroller";
    static eventer = {
        /** @Deprecated bruk PresentasjonsmodusTjenesteForAjs */
        presentasjonsmodusAktivert: 'BasisKontroller.eventer.presentasjonsmodusAktivert',
        /** @Deprecated bruk PresentasjonsmodusTjenesteForAjs */
        presentasjonsmodusDeaktivert: 'BasisKontroller.eventer.presentasjonsmodusDeaktivert',
        fokuserNyttMøteKnapp: 'BasisKontroller.eventer.fokuserNyttMøteKnapp',
        draOgSlippDokumenterAktiver: 'BasisKontroller.eventer.draOgSlippDokumenterAktivert',
        draOgSlippDokumenterSluppet: 'BasisKontroller.eventer.draOgSlippDokumenterFilSluppet',
        draOgSlippDokumenterTilValidering: 'BasisKontroller.eventer.draOgSlippDokumenterFilTilValidering',
        draOgSlippDokumenterIkkeAktivertDokumentSluppet: 'BasisKontroller.eventer.draOgSlippDokumenterIkkeAktivertDokumentSluppet'
    };

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$window,
            regNavn.ng.$scope,
            regNavn.ng.ui.$state,
            regNavn.ng.ui.$transitions,
            regNavn.ng.$q,
            regNavn.ng.$timeout,
            regNavn.ng.$animate,
            regNavn.md.$mdSidenav,
            Kontekst.regNavn,
            Konfigurasjon.regNavn,
            WebNavigasjon.regNavn,
            OppgaveRessurs.regNavn,
            RedigerOppgaveDialog.regNavn,
            ModelloppdateringTjeneste.regNavn,
            Utlogging.regNavn,
            regNavn.md.$mdDialog,
            KlientinformasjonFraUserAgent.regNavn,
            MøteTjeneste.regNavn,
            ng2RegNavn.PresentasjonsmodusTjenesteForAjs,
            ng2RegNavn.CdkScrollableSomTjenesteForAjs,
            ng2RegNavn.Ng2DialogTjenesterForAjs,
            BasisKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                private $window: IWindowService,
                private $scope: IScope,
                private $state: StateService,
                private $transitions: TransitionService,
                private $q: IQService,
                private $timeout: ITimeoutService,
                private $animate: any,
                private $mdSidenav: angular.material.ISidenavService,
                kontekst: Kontekst,
                private konfigurasjon: Konfigurasjon,
                private navigasjon: WebNavigasjon,
                private oppgaveRes: OppgaveRessurs,
                private oppgaveDialog: RedigerOppgaveDialog,
                modelloppdatering: ModelloppdateringTjeneste,
                private utlogging: Utlogging,
                private $mdDialog: angular.material.IDialogService,
                private klientinformasjon: KlientinformasjonFraUserAgent,
                private møteTjeneste: MøteTjeneste,
                private presentasjonsmodusTjenesteForAjs: PresentasjonsmodusTjenesteForAjs,
                private cdkScrollableSomTjenesteForAjs: CdkScrollableSomTjenesteForAjs,
                private ng2DialogTjenesterForAjs: Ng2DialogTjenesterForAjs) {
        this.nettleserSpesifikkCssKlasse = this.initNettleserSpesifikkCssKlasse();
        this.featurevalg = kontekst.featurevalg();
        this.bruker = kontekst.autentisertBruker();

        this.$scope.$on(Kontekst.brukerRelastetEvent, () => {
            this.bruker = kontekst.autentisertBruker();
        });

        this.initAntallForalteOppgaver();

        modelloppdatering.vedNyOppgave(o => true, $scope, o => this.initAntallForalteOppgaver());
        modelloppdatering.vedOppdatertOppgave(o => true, $scope, o => this.initAntallForalteOppgaver());
        modelloppdatering.vedSlettetOppgave(o => true, $scope, o => this.initAntallForalteOppgaver());
        this.lyttTilPresentasjonsmodusEvent();
        this.lyttTilFokuserNyttMøteKnapp();
        this.lyttTilAktivtMøteEvent();
    }


    featurevalg: l.Featurevalg;
    bruker: l.EnkelBrukerModell;
    antallForfaltOppgaver = 0;
    aktivtMoeteId: string | null = null;

    presentasjonmodusAktiv = false;
    nettleserSpesifikkCssKlasse: string;

    plussMenyAapen = false;
    plussMenyLukkVedMusut = true;
    // settes til true når man klikker loggut for å unngå dobbeltklikk
    loggerUt = false;

    private cdkScrollableForAngittElement: CdkScrollable | null = null;

    byttPresentasjonsmodus() {
        this.presentasjonsmodusTjenesteForAjs.tjeneste().then(presentasjonsmodusTjeneste => presentasjonsmodusTjeneste.settAktivert(!this.presentasjonmodusAktiv));
    }

    /** forhindrer at klikk på åpen speed dial fører til at denne lukkes*/
    vedSpeeddialKlikk($event: IAngularEvent) {
        this.plussMenyLukkVedMusut = true;
        if (this.plussMenyAapen && this.konfigurasjon.wkMenyHoverTriggerAktivert) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }


    antallKall() {
        return window.performance.getEntriesByType("resource").length
    }

    nullStillAntallKall() {
        return window.performance.clearResourceTimings();
    }

    visAntallKall() {
        return this.konfigurasjon.miljø === Miljø.test;
    }

    vedSpeeddialMusover() {
        if (!this.konfigurasjon.wkMenyHoverTriggerAktivert) return;
        this.plussMenyAapen = true;
    }

    vedSpeeddialMusut() {
        if (!this.plussMenyLukkVedMusut) return;
        if (!this.konfigurasjon.wkMenyHoverTriggerAktivert) return;
        this.plussMenyAapen = false;
    }

    visHjelp() {
        this.ng2DialogTjenesterForAjs.visHjelpDialog();
    }

    loggUt() {
        if (this.loggerUt) return;
        this.loggerUt = true;
        this.utlogging.loggUt().finally(() =>
          this.loggerUt = false
        );
    }

    visMeny() {
        this.venstremenyKontroller().toggle();
    }

    nyttMoete() {
        this.møteTjeneste.nyttMøteDialog();
    }

    nyOppgave() {
        this.oppgaveDialog.visNyFrittståendeOppgaveDialog();
    }

    gaaTilDashboard() {
        if (this.$state.current.data.modulnavn == WebModulnavn.dashboard) return;
        this.navigasjon.gåTilStartsiden();
    }

    gaaTilFoerstkommendeMoete() {
        this.navigasjon.gåTilFørsteTilgjengeligeMøte();
    }

    aktivModulNavn() {
        switch (this.$state.current.data.modulnavn) {
            case WebModulnavn.dashboard:
                return "modul-dashboard";
            case WebModulnavn.plan:
                return "modul-plan";
            case WebModulnavn.møte:
                return "modul-moete";
            case WebModulnavn.oppgave:
                return "modul-oppgave";
            case WebModulnavn.kommentar:
                return "modul-kommentar";
            case WebModulnavn.gruppe:
                return "modul-gruppe";
            case WebModulnavn.beslutninger:
                return "modul-beslutninger";
            case WebModulnavn.administrasjon:
                return "modul-administrasjon";
            case WebModulnavn.arkiv:
                return "modul-arkiv";
            default:
                console.warn(`aktiv modul ${this.$state.current.data.modulnavn} er ikke håndtert, vennligt legg denne til i BasisKontroller.aktivModulNavn()`);
                return "modul-udefinert";
        }
    }

    erAktivModul(modulNavn) {
        return this.aktivModulNavn() === modulNavn;
    }

    navigasjonDeaktivert() {
        return this.navigasjon.navigasjonDeaktivert();
    }

    $onInit(): void {
        if (this.$state.current.data['modulnavn'] === WebModulnavn.møte)
            this.aktivtMoeteId = this.$state.params.id;

        this.cdkScrollableSomTjenesteForAjs.tjeneste().then(cdkScrollableSomTjeneste => {
            let skrollKontainer = this.$element.find('.basisside .basisside-innhold')[0];
            this.cdkScrollableForAngittElement = cdkScrollableSomTjeneste.registrerElementSomSkrollbart(skrollKontainer);
            this.cdkScrollableForAngittElement.ngOnInit();
        });
    }

    $onDestroy() {
        this.cdkScrollableForAngittElement?.ngOnDestroy();
    }

    //hjelpemetoder

    private initAntallForalteOppgaver() {
        this.oppgaveRes.aggregerteOppgaverMedFristIPerioden(new Date(), new Date()).$promise
          .then(aggregater => this.antallForfaltOppgaver = aggregater.bruker.forfalte);
    }

    private venstremenyKontroller() {
        return this.$mdSidenav('venstremeny');
    }

    private lyttTilPresentasjonsmodusEvent() {
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusAktivert, () => {
            this.presentasjonmodusAktiv = true;
            this.venstremenyKontroller().close();
        });
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusDeaktivert, () => {
            this.presentasjonmodusAktiv = false;
            this.venstremenyKontroller().open();
        });
    }

    private lyttTilFokuserNyttMøteKnapp() {
        this.$scope.$on(BasisKontroller.eventer.fokuserNyttMøteKnapp, () =>
          this.pulserNyttMøteKnapp());
    }

    /**
     * For markering av aktivt møte lytter vi til $transitions.onStart.
     */
    private lyttTilAktivtMøteEvent() {
        const møtenavigasjonslytter = this.$transitions.onStart({to: 'innhold.moete.**'}, trans => {
            if (trans.to().data['modulnavn'] === WebModulnavn.møte)
                this.aktivtMoeteId = trans.params().id;
            else
                this.aktivtMoeteId = null;
        });
        this.$scope.$on('$destroy', (e) => møtenavigasjonslytter());
    }

    /**
     * Sørger for å generer en css klasse som inneholder nettlesernavnet, eks
     * nettleser_microsoft-edge og nettleser_internet-explorer.
     */
    private initNettleserSpesifikkCssKlasse() {
        return `nettleser_${this.klientinformasjon.kallendeklientinformasjon().nettleserNavn.toLocaleLowerCase().replace(' ', '-')}`
    }

    private pulserNyttMøteKnapp() {
        const fokusKlasse = 'basisside-nyttmøteknapp-fokus';
        this.$timeout(() => {
            const nyttMøteKnapp = this.$element.find('button.basisside-nyttmøteknapp');
            nyttMøteKnapp.removeClass(fokusKlasse);//fjern eventuell kjørende animasjon
            this.$animate.addClass(nyttMøteKnapp, fokusKlasse)
              .then(() => this.$animate.removeClass(nyttMøteKnapp, fokusKlasse));
        }, 100);
    }
}
